import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { COMPANY } from "@/lib/seo";

const FloatingCallButton = () => (
  <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-charcoal/95 backdrop-blur-md border-t border-charcoal-foreground/10 px-4 py-3 flex items-center gap-3">
    <a
      href={`tel:${COMPANY.phoneTel}`}
      data-cta="floating"
      className="flex-1 flex items-center justify-center gap-2 bg-primary text-primary-foreground rounded-lg py-3 font-heading font-bold text-sm hover:opacity-90 transition-opacity"
      aria-label="Call Hadley Energy Solutions"
    >
      <Phone className="w-4 h-4" />
      Call Now
    </a>
    <Link
      to="/request-estimate"
      className="flex-1 flex items-center justify-center gap-2 bg-white text-foreground rounded-lg py-3 font-heading font-bold text-sm hover:opacity-90 transition-opacity"
    >
      Free Estimate
      <ArrowRight className="w-4 h-4" />
    </Link>
  </div>
);

export default FloatingCallButton;
